import React from "react";
import Image from "next/image";

interface BenefitItemProps {
    text: string;
    type?: "success" | "error" | "warning";
}

const BenefitItem: React.FC<BenefitItemProps> = ({ text, type = "success" }) => (
    <div className="flex items-start gap-2.5 py-3">
        <div className="min-w-5 h-5" >
            {type === "success" ?
                <Image src='/assets/icons/check.svg' alt="Check" width={20} height={20} />
                :
                type === "error" ? <Image src='/assets/icons/cross.svg' alt="Cross" width={20} height={20} /> :
                    <Image src='/assets/icons/orange-check.svg' alt="Check" width={20} height={20} />}
        </div>
        <p className={`text-[14px] leading-5 tracking-[0.2px] text-[#1D1D1D]`}>{text}</p>
    </div>
);

export default BenefitItem;
